var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#333"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.423 20.734l-4.188-4.187L15.91 3.873l4.187 4.187zM1.626 22.344l5.207-1.054-4.152-4.15zM22.191 5.147l-3.31-3.309a.619.619 0 00-.877-.001l-1.507 1.506 4.188 4.188 1.507-1.507a.617.617 0 00-.001-.877z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzMzMzMzMyI+CjxnPgoJPHJlY3QgeD0iOC43MDUiIHk9IjMuMzQyIiB0cmFuc2Zvcm09Im1hdHJpeCgtMC43MDcxIC0wLjcwNzEgMC43MDcxIC0wLjcwNzEgMTEuMjE1MSAyOS4yNTI5KSIgd2lkdGg9IjUuOTIyIiBoZWlnaHQ9IjE3LjkyNCIvPgoJPHBvbHlnb24gcG9pbnRzPSIxLjYyNiwyMi4zNDQgNi44MzMsMjEuMjkgMi42ODEsMTcuMTQgIi8+Cgk8cGF0aCBkPSJNMjIuMTkxLDUuMTQ3bC0zLjMxLTMuMzA5Yy0wLjI0Mi0wLjI0My0wLjYzNC0wLjI0NC0wLjg3Ny0wLjAwMWwtMS41MDcsMS41MDZsNC4xODgsNC4xODhsMS41MDctMS41MDcgQzIyLjQzNSw1Ljc4MywyMi40MzYsNS4zOTMsMjIuMTkxLDUuMTQ3eiIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgEdit as ReactComponent };